import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4508f59e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "print",
  class: "position-relative"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "blue-bg p-3",
  style: {"font-size":"15px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1" }, " 店頭外国為替証拠金取引・証券CFD取引・商品CFD取引口座設定申込書 "),
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1" }, " 兼 口座設定約諾書 兼 顧客カード 兼 外国証券取引口座設定申込書 "),
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1" }, " 兼 取引時確認記録簿 特定取引を行う者の届出書 兼 外国PEPSに関する申告書 "),
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1" }, " 兼 情報共有に関する同意書 兼 印鑑票 兼 申請書 ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end gap-6" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center bk-border no-bb",
      style: {"width":"96%"}
    }, " 部店 "),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-3 mt-2" }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "checkbox",
        style: {"width":"33px","height":"50px"}
      }),
      /*#__PURE__*/_createElementVNode("div", {
        class: "checkbox",
        style: {"width":"33px","height":"50px"}
      }),
      /*#__PURE__*/_createElementVNode("div", {
        class: "checkbox",
        style: {"width":"33px","height":"50px"}
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center bk-border no-bb",
      style: {"width":"98%"}
    }, " 口座番号 "),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-3 mt-2" }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "checkbox",
        style: {"width":"33px","height":"50px"}
      }),
      /*#__PURE__*/_createElementVNode("div", {
        class: "checkbox",
        style: {"width":"33px","height":"50px"}
      }),
      /*#__PURE__*/_createElementVNode("div", {
        class: "checkbox",
        style: {"width":"33px","height":"50px"}
      }),
      /*#__PURE__*/_createElementVNode("div", {
        class: "checkbox",
        style: {"width":"33px","height":"50px"}
      }),
      /*#__PURE__*/_createElementVNode("div", {
        class: "checkbox",
        style: {"width":"33px","height":"50px"}
      }),
      /*#__PURE__*/_createElementVNode("div", {
        class: "checkbox",
        style: {"width":"33px","height":"50px"}
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end align-items-center mt-5 w-100" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, "扱者"),
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-3" }, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "checkbox",
          style: {"width":"33px","height":"50px"}
        }),
        /*#__PURE__*/_createElementVNode("div", {
          class: "checkbox",
          style: {"width":"33px","height":"50px"}
        }),
        /*#__PURE__*/_createElementVNode("div", {
          class: "checkbox",
          style: {"width":"33px","height":"50px"}
        })
      ])
    ])
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/images/logos/jp-logo-sm.jpg",
      alt: "logo",
      style: {"width":"30px","height":"35px"}
    }),
    /*#__PURE__*/_createElementVNode("div", null, "あい証券株式会社 御中"),
    /*#__PURE__*/_createElementVNode("div", null, "税務署長 殿")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-8 ms-1" }, [
    /*#__PURE__*/_createElementVNode("div", null, " 私は、「反社会的勢力でないことの確約に関する同意書」について確約の上、貴社の「約款・規定集」に基づき、総合取引口座を申し込みます。 "),
    /*#__PURE__*/_createElementVNode("div", null, " 私は、所得税法施行令第343条第3項の適用を受けたいのでこの旨申請します。 "),
    /*#__PURE__*/_createElementVNode("div", null, " 私は、本申込みに係る情報は、貴社が定める個人情報の利用目的の範囲内で利用すること、及び担当の金融商品仲介業が、私の金融商品取引に関する情報を共有し、相互に提供しあうことに同意します。 ")
  ])
], -1))
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 ms-1" }, "全ての項目にご記入、ご捺印ください。", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-5 p-3 text-center" }, "お申込日", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row h-100 align-items-center",
  style: {"width":"90%"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end" }, "年"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end" }, "月"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end" }, "日")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center fw-bold" }, "フリガナ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row ms-1 mt-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, "セイ"),
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, "メイ")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center fw-bold" }, "性 別", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center fw-bold" }, "お届出印鑑", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex align-items-center justify-content-center h-100 fw-bold" }, " お名前 ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bk-border no-br no-bt h-100" }, [
  /*#__PURE__*/_createElementVNode("div", null, "（自署）"),
  /*#__PURE__*/_createElementVNode("div", { class: "row ms-1" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col" }, "姓"),
    /*#__PURE__*/_createElementVNode("div", { class: "col" }, "名")
  ])
], -1))
const _hoisted_15 = { class: "p-3 d-flex align-items-center justify-content-center gap-4 h-100" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = ["checked"]
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = ["checked"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex align-items-center justify-content-center h-100 fw-bold" }, " 生年月日 ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row h-100 align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end" }, "年"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end" }, "月"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end" }, "日")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex align-items-center justify-content-center h-100 fw-bold" }, " 年齢 ", -1))
const _hoisted_23 = { class: "ms-2 p-3 h-100" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "印", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex flex-column align-items-center justify-content-center h-100 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Email"),
  /*#__PURE__*/_createElementVNode("div", null, "アドレス")
], -1))
const _hoisted_27 = { class: "ms-2 p-3 h-100" }
const _hoisted_28 = { class: "d-flex align-items-center h-100" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex align-items-center justify-content-center h-100 fw-bold" }, " 電話 ", -1))
const _hoisted_30 = { class: "ms-2 p-3 h-100" }
const _hoisted_31 = { class: "d-flex align-items-center h-100" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-end justify-content-center",
  style: {"height":"70%"},
  z: ""
}, " （シャチハタ不可） ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex align-items-center justify-content-center h-100 fw-bold" }, " ご住所 ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bk-border no-bt" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex ms-2 align-items-center p-3" }, [
    /*#__PURE__*/_createElementVNode("div", null, "〒")
  ])
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bk-border no-bt" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-3" }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"height":"85px"} }, "（自署）"),
    /*#__PURE__*/_createElementVNode("div", { class: "blue-text fs-9 mt-2" }, " 本人確認書類と同一内容をご記載ください。なお、本人確認書類に記載のない建物棟番号またはマンション名等を追加記載の場合は公共料金領収書等をご提示ください。 ")
  ])
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex align-items-center h-100 fw-bold" }, " ご本人のお勤め先 ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex align-items-center justify-content-center h-100" }, " 勤務先名称 ", -1))
const _hoisted_38 = { class: "ms-1 p-3 d-flex align-items-center h-100" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex align-items-center justify-content-center h-100" }, " 所属部署 ", -1))
const _hoisted_40 = { class: "ms-1 p-3 d-flex align-items-center h-100" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex align-items-center justify-content-center h-100" }, " お役職 ", -1))
const _hoisted_42 = { class: "ms-1 p-3 d-flex align-items-center h-100" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex flex-column align-items-center justify-content-center h-100" }, [
  /*#__PURE__*/_createElementVNode("div", null, "勤務先電話")
], -1))
const _hoisted_44 = { class: "ms-1 p-3 d-flex align-items-center h-100" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex flex-column align-items-center justify-content-center h-100 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("div", null, "ご職業")
], -1))
const _hoisted_46 = { class: "ms-1 p-3 d-flex align-items-center h-100" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex flex-column align-items-center justify-content-center h-100" }, [
  /*#__PURE__*/_createElementVNode("div", null, "国籍情報")
], -1))
const _hoisted_48 = { class: "p-3 pt-2 ms-1 d-flex align-items-center gap-4" }
const _hoisted_49 = { class: "d-flex align-items-center" }
const _hoisted_50 = ["checked"]
const _hoisted_51 = { class: "d-flex align-items-center" }
const _hoisted_52 = ["checked"]
const _hoisted_53 = { class: "text-underline ms-1" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-2 pt-3 pb-2 fs-9" }, " ※米国籍を保有されている方の口座開設には対応しておりません。 ", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex flex-column align-items-center justify-content-center h-100 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("div", null, "居住国")
], -1))
const _hoisted_56 = { class: "p-3 pt-2 ms-1 d-flex align-items-center gap-4" }
const _hoisted_57 = { class: "d-flex align-items-center" }
const _hoisted_58 = ["checked"]
const _hoisted_59 = { class: "d-flex align-items-center" }
const _hoisted_60 = ["checked"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-2 pt-3 pb-2 fs-9" }, " ※日本国外にお住まいの方の口座開設には対応しておりません。 ", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex flex-column align-items-center justify-content-center h-100 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("div", null, "米国の納税義務")
], -1))
const _hoisted_63 = { class: "p-3 ms-1" }
const _hoisted_64 = { class: "d-flex align-items-center" }
const _hoisted_65 = ["checked"]
const _hoisted_66 = { class: "d-flex align-items-center mt-2" }
const _hoisted_67 = ["checked"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 ms-1 fs-9" }, " ※税法上の米国居住者とは、「グリーンカード（アメリカにおける外国人永住権）の所有者」 または「一般的には、その年の米国滞在住期間が31日以上でかつその年を含めた過去3 年間の米国滞在住期間の合計が183日以上の個人」を指します。 ", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "外国PEPs・内国PEPs・国際機関PEPsに関する申告", -1))
const _hoisted_70 = { class: "d-flex" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "外国政府等外国政府等・内国政府等・国際機関等"),
  /*#__PURE__*/_createElementVNode("div", null, "において重要な公的位置にある方（過去も含む）"),
  /*#__PURE__*/_createElementVNode("div", null, "及びそ の親族に該当しますか？")
], -1))
const _hoisted_72 = { class: "ms-20" }
const _hoisted_73 = { class: "d-flex align-items-center ms-1" }
const _hoisted_74 = ["checked"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center h-100" }, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-1" }, "いいえ", -1))
const _hoisted_77 = { class: "ms-4" }
const _hoisted_78 = { class: "d-flex align-items-center ms-1" }
const _hoisted_79 = ["checked"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center h-100" }, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-1" }, "はい", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, " ※別紙[外国PEPSに関する申告書「ご記入上の注意」]をご確認ください。 ", -1))
const _hoisted_83 = { class: "ms-6 mt-1" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "「はい」の場合は、具体的にご記入ください。", -1))
const _hoisted_85 = {
  class: "bk-border mt-2",
  style: {"height":"40px"}
}
const _hoisted_86 = { class: "ps-2" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex flex-column align-items-center justify-content-center h-100" }, [
  /*#__PURE__*/_createElementVNode("div", null, "アカウントタイプ")
], -1))
const _hoisted_88 = { class: "p-3 pt-2 ms-1" }
const _hoisted_89 = { class: "d-flex align-items-center" }
const _hoisted_90 = ["checked"]
const _hoisted_91 = { class: "d-flex align-items-center mt-2" }
const _hoisted_92 = ["checked"]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bk-border no-bt no-br no-bl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex flex-column align-items-center justify-content-center" }, [
    /*#__PURE__*/_createElementVNode("div", null, "ご希望お取引口座")
  ])
], -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center d-flex flex-column align-items-center justify-content-center" }, [
    /*#__PURE__*/_createElementVNode("div", null, "投資家区分")
  ])
], -1))
const _hoisted_95 = { class: "bk-border no-bt no-br no-bl" }
const _hoisted_96 = { class: "p-3 text-center d-flex align-items-center gap-5" }
const _hoisted_97 = ["checked"]
const _hoisted_98 = { class: "p-3 text-center d-flex align-items-center gap-5" }
const _hoisted_99 = ["checked"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 ms-2 h-100 d-flex align-items-center gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "振込先口座指定")
], -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center bb bg-gray" }, [
  /*#__PURE__*/_createElementVNode("div", null, "金融機関名")
], -1))
const _hoisted_102 = { class: "p-3 text-center" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center bb bg-gray" }, [
  /*#__PURE__*/_createElementVNode("div", null, "金融機関コード")
], -1))
const _hoisted_104 = { class: "p-3 text-center" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center bb bg-gray" }, [
  /*#__PURE__*/_createElementVNode("div", null, "支店名")
], -1))
const _hoisted_106 = { class: "p-3 text-center" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center bb bg-gray" }, [
  /*#__PURE__*/_createElementVNode("div", null, "支店コード")
], -1))
const _hoisted_108 = { class: "p-3 text-center" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center bb bg-gray" }, [
  /*#__PURE__*/_createElementVNode("div", null, "預金の種類")
], -1))
const _hoisted_110 = { class: "p-3 text-center" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center bb bg-gray" }, [
  /*#__PURE__*/_createElementVNode("div", null, "口座番号")
], -1))
const _hoisted_112 = { class: "p-3 text-center" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center bb bg-gray" }, [
  /*#__PURE__*/_createElementVNode("div", null, "口座名義人(全角)")
], -1))
const _hoisted_114 = { class: "p-3 text-center" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-center bb bg-gray" }, [
  /*#__PURE__*/_createElementVNode("div", null, "口座名義人(全角カタカナ)")
], -1))
const _hoisted_116 = { class: "p-3 text-center" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-break" }, null, -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 ms-2 h-100 d-flex align-items-center gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "顧客カード")
], -1))
const _hoisted_119 = { class: "p-3 pt-2 ms-1" }
const _hoisted_120 = { class: "p-3 pt-2 ms-1" }
const _hoisted_121 = { class: "p-3 pt-2 ms-1" }
const _hoisted_122 = { class: "p-3 pt-2 ms-1" }
const _hoisted_123 = { class: "p-3 pt-2 ms-1" }
const _hoisted_124 = { class: "p-3 pt-2 ms-1" }
const _hoisted_125 = { class: "p-3 pt-2 ms-1" }
const _hoisted_126 = { class: "h-100 ms-1 d-flex flex-wrap gap-4 align-items-center" }
const _hoisted_127 = { class: "row mb-1 gap-10" }
const _hoisted_128 = { class: "col col-3 d-flex align-items-center justify-content-between" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "FX (外国為替証拠金取引)", -1))
const _hoisted_130 = { class: "checkbox-css mx-1" }
const _hoisted_131 = { class: "d-flex align-items-center justify-content-center h-100 p-3" }
const _hoisted_132 = { class: "col col-3 d-flex align-items-center justify-content-between" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "株式取引（信用）", -1))
const _hoisted_134 = { class: "checkbox-css mx-1" }
const _hoisted_135 = { class: "d-flex align-items-center justify-content-center h-100 p-3" }
const _hoisted_136 = { class: "col col-3 d-flex align-items-center justify-content-between" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "商品先物取引", -1))
const _hoisted_138 = { class: "checkbox-css mx-1" }
const _hoisted_139 = { class: "d-flex align-items-center justify-content-center h-100 p-3" }
const _hoisted_140 = { class: "row mb-1 mt-2 gap-10" }
const _hoisted_141 = { class: "col col-3 d-flex align-items-center justify-content-between" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "株式取引(現物)", -1))
const _hoisted_143 = { class: "checkbox-css mx-1" }
const _hoisted_144 = { class: "d-flex align-items-center justify-content-center h-100 p-3" }
const _hoisted_145 = { class: "col col-3 d-flex align-items-center justify-content-between" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "指数・オプション", -1))
const _hoisted_147 = { class: "checkbox-css mx-1" }
const _hoisted_148 = { class: "d-flex align-items-center justify-content-center h-100 p-3" }
const _hoisted_149 = { class: "col col-3 d-flex align-items-center justify-content-between" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "その他デリバティブ取引", -1))
const _hoisted_151 = { class: "checkbox-css mx-1" }
const _hoisted_152 = { class: "d-flex align-items-center justify-content-center h-100 p-3" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dash_line mt-8 w-100" }, null, -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-7 ms-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, "＜社用使用欄＞"),
  /*#__PURE__*/_createElementVNode("div", null, "本人確認記録簿")
], -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row row-cols-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      class: "styled-checkbox"
    }),
    /*#__PURE__*/_createTextVNode(" 訪問原本提示 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      class: "styled-checkbox"
    }),
    /*#__PURE__*/_createTextVNode(" 来社原本提示 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      class: "styled-checkbox"
    }),
    /*#__PURE__*/_createTextVNode(" 郵送 ")
  ])
], -1))
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row row-cols-3 mt-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      class: "styled-checkbox"
    }),
    /*#__PURE__*/_createTextVNode(" 運転免許証 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      class: "styled-checkbox"
    }),
    /*#__PURE__*/_createTextVNode(" 個人番号カード ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      class: "styled-checkbox"
    }),
    /*#__PURE__*/_createTextVNode(" 各種健康保険証 ")
  ])
], -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row row-cols-3 mt-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      class: "styled-checkbox"
    }),
    /*#__PURE__*/_createTextVNode(" 在留カード ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      class: "styled-checkbox"
    }),
    /*#__PURE__*/_createTextVNode(" 印鑑登録証明書 ")
  ])
], -1))
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center col-8" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      class: "styled-checkbox"
    }),
    /*#__PURE__*/_createTextVNode(" 住民票の写し又は記載事項全部証明書 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center col-4" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      class: "styled-checkbox"
    }),
    /*#__PURE__*/_createTextVNode(" その他（ ） ")
  ])
], -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex mt-4 justify-content-between me-14" }, [
  /*#__PURE__*/_createElementVNode("div", null, "確認日："),
  /*#__PURE__*/_createElementVNode("div", null, "年"),
  /*#__PURE__*/_createElementVNode("div", null, "月"),
  /*#__PURE__*/_createElementVNode("div", null, "時刻")
], -1))
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex mt-4 justify-content-between me-14" }, [
  /*#__PURE__*/_createElementVNode("div", null, "取引関係文書送付日："),
  /*#__PURE__*/_createElementVNode("div", null, "年"),
  /*#__PURE__*/_createElementVNode("div", null, "月"),
  /*#__PURE__*/_createElementVNode("div", null, "時刻")
], -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, "確認者：", -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "到底口座を開設する金融商品取引業者の営業所"),
  /*#__PURE__*/_createElementVNode("li", null, " 上場株式等の譲渡の対価を支払をする金融商品取引業者の営業所 "),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", null, " 上場株式等の配当、公社債の利子、投資信託の収益の分配、国外 "),
    /*#__PURE__*/_createElementVNode("div", null, "発行株式等の配当の支払の取扱者")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "先物取引の差金等決済を行う先物取引業者の営業所"),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", null, " 特定上場株式配当等勘定が設けられた源泉徴収選択口座が開設さ "),
    /*#__PURE__*/_createElementVNode("div", null, "れている金融商品取引業者等の営業所")
  ])
], -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "名称", -1))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " ", -1))
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "所在地", -1))
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/logos/jp-logo-sm.jpg",
    alt: "logo",
    style: {"width":"15px","height":"20px"}
  })
], -1))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "〒", -1))
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "あい証券株式会社", -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "106-6007", -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "東京都港区六本木1-6-1泉ガーデンタワー7F", -1))
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-1" }, "受付印", -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "dotted-circle" })
], -1))
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dash_line mt-4 w-100" }, null, -1))

import { inject } from "vue";
import { occupations } from "@/core/types/jp/verificationInfo";
import {
  accountRoles,
  accountTypesSelection,
  investorDistinctionSelection,
  financialInstiutionTypes,
  depositTypesSelection,
  moneyRange,
  mainIncomeSources,
  transactionMotives,
  mainFunds,
  experienceSelections,
  investmentPurposes,
  assetManagementPeriodSelection,
} from "@/core/types/jp/verificationFinancial";
import { getDataByCode } from "@/core/data/phonesData";
import { createI18n } from "vue-i18n";
import messages from "@/locales/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'JpPdf',
  setup(__props) {

const items = inject<any>("verificationDetails");

function getLabelByValue(value, array) {
  const data = array.find((data) => data.value === value);
  return data ? data.label : null;
}

const getItemByValue = (value, items) => {
  if (Array.isArray(items)) {
    return (
      items.find((item) => item.value === value) || { label: "", value: "" }
    );
  } else if (typeof items === "object") {
    return (
      Object.values(items).find((item) => item.value === value) || {
        label: "",
        value: "",
      }
    );
  }
  return {
    label: "",
    value: "",
  };
};

const i18n = createI18n({
  legacy: false,
  locale: "jp-jp",
  globalInjection: false,
  messages,
  fallbackLocale: "en-us",
});

const t = i18n.global.t;

function convertToJpLanguage(arrayToTranslate) {
  const originalData = arrayToTranslate.value;
  return originalData.map((item) => ({
    ...item,
    label: t(item.langKey),
  }));
}

function coverToJpLanguageForReactiveObject(objectToTranslate) {
  const originalData = objectToTranslate;
  return originalData.map((item) => ({
    ...item,
    label: t(item.langKey),
  }));
}

const jpMoneyRange = convertToJpLanguage(moneyRange);
const jpAccountTypes = convertToJpLanguage(accountTypesSelection);
const jpInvestorDistinction = coverToJpLanguageForReactiveObject(
  investorDistinctionSelection
);
const jpFinancialInstitutionTypes = convertToJpLanguage(
  financialInstiutionTypes
);

const jpDepositTypes = convertToJpLanguage(depositTypesSelection);
const jpMainIncomeSources = convertToJpLanguage(mainIncomeSources);
const jpTransactionMotives = convertToJpLanguage(transactionMotives);
const jpMainFunds = convertToJpLanguage(mainFunds);
const jpExperienceSelections = convertToJpLanguage(experienceSelections);
const jpInvestmentPurposes = convertToJpLanguage(investmentPurposes);
const jpAssetManagementPeriod = convertToJpLanguage(
  assetManagementPeriodSelection
);

const jpOccupations = convertToJpLanguage(occupations);

function getYear(isoString) {
  return new Date(isoString).getFullYear(); // Extracts the year
}

function getMonth(isoString) {
  return new Date(isoString).getMonth() + 1; // Extracts the month
}

function getDay(isoString) {
  return new Date(isoString).getDate(); // Extracts the day
}

function formatJapanesePhoneNumber(phoneNumber) {
  // Remove any existing hyphens or spaces
  phoneNumber = phoneNumber.replace(/[-\s]/g, "");

  // Check for mobile phone number pattern
  if (/^0[789]0\d{8}$/.test(phoneNumber)) {
    // Format as 090-1234-5678
    return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  }
  // Check for landline with 3-digit area code (e.g., Tokyo: 03-1234-5678)
  else if (/^0\d{1,2}\d{8}$/.test(phoneNumber)) {
    // Format as 03-1234-5678 or 045-123-4567 based on area code
    return phoneNumber.replace(/(\d{2,4})(\d{3,4})(\d{4})/, "$1-$2-$3");
  }
  // Default: Return the unformatted phone number if it doesn't match patterns
  return phoneNumber;
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 13 }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 11,
            class: "ps-10"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_row, { class: "justify-content-between" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              class: "blue-bg fs-5 fw-bold",
              span: 8
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }),
            _createVNode(_component_el_col, {
              span: 2,
              class: "text-end p-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode("（自署）")
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 2,
              class: "bk-border no-br no-bb blue-bg"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 8,
              class: "bk-border no-bb"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { class: "position-relative" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 2,
              class: "blue-bg bk-border no-border-right"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 14,
              class: "bk-border no-br"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "bk-border blue-bg no-br"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "bk-border blue-bg"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 2,
              class: "blue-bg bk-border no-br no-bt"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 14 }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "bk-border bg-gray no-br no-bt"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "styled-checkbox",
                      checked: _unref(items).info.gender == 0
                    }, null, 8, _hoisted_17),
                    _createTextVNode(" 男 ")
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "styled-checkbox",
                      checked: _unref(items).info.gender == 1
                    }, null, 8, _hoisted_19),
                    _createTextVNode(" 女 ")
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "bk-border no-bt no-bb fs-8 text-center pt-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" お忘れなくご捺印ください ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 2,
              class: "blue-bg bk-border no-br no-bt"
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 2,
              class: "bk-border no-br no-bt p-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode("（自署）")
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 6,
              class: "bk-border no-br no-bt no-bl"
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 2,
              class: "blue-bg bk-border no-br no-bt"
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 8,
              class: "bk-border bg-gray no-bt no-br"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(items).info.age) + " 歳 ", 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "bk-border no-bt no-bb text-center fs-8"
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 2,
              class: "blue-bg bk-border no-br no-bt"
            }, {
              default: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 8,
              class: "bk-border no-bt no-br bg-gray"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(items).info.email), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 2,
              class: "blue-bg bk-border no-br no-bt"
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 8,
              class: "bk-border no-bt no-br bg-gray"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(items).info.phone), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "bk-border no-bt text-center fs-8"
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 2,
              class: "blue-bg bk-border no-br no-bt"
            }, {
              default: _withCtx(() => [
                _hoisted_33
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 22 }, {
              default: _withCtx(() => [
                _hoisted_34,
                _hoisted_35
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { class: "mt-8" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 24,
              class: "bk-border blue-bg"
            }, {
              default: _withCtx(() => [
                _hoisted_36
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 2,
              class: "bk-border no-br no-bt blue-bg"
            }, {
              default: _withCtx(() => [
                _hoisted_37
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 6,
              class: "bk-border no-br no-bt"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(items).info.companyName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 2,
              class: "bk-border no-br no-bt blue-bg"
            }, {
              default: _withCtx(() => [
                _hoisted_39
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 6,
              class: "bk-border no-br no-bt"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(items).info?.affiliatedDepartment), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 2,
              class: "bk-border no-br no-bt blue-bg"
            }, {
              default: _withCtx(() => [
                _hoisted_41
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 6,
              class: "bk-border no-bt"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(items).info?.affiliatedPosition), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 2,
              class: "bk-border no-br no-bt blue-bg"
            }, {
              default: _withCtx(() => [
                _hoisted_43
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 6,
              class: "bk-border no-br no-bt"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(items).info?.companyPhone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 2,
              class: "bk-border blue-bg no-br no-bt"
            }, {
              default: _withCtx(() => [
                _hoisted_45
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 14,
              class: "bk-border no-bt"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", null, _toDisplayString(getLabelByValue(_unref(items).info.occupation, _unref(jpOccupations))), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { class: "mt-8" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 2,
              class: "bk-border no-br blue-bg"
            }, {
              default: _withCtx(() => [
                _hoisted_47
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 10,
              class: "bk-border no-br"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "styled-checkbox",
                      checked: _unref(items).info.citizen == 'jp'
                    }, null, 8, _hoisted_50),
                    _createTextVNode(" 日本 ")
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "styled-checkbox",
                      checked: _unref(items).info.citizen != 'jp'
                    }, null, 8, _hoisted_52),
                    _createTextVNode(" その他 ")
                  ]),
                  _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(getDataByCode)(_unref(items).info?.otherCitizen)?.name), 1)
                ]),
                _hoisted_54
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 2,
              class: "bk-border blue-bg no-br"
            }, {
              default: _withCtx(() => [
                _hoisted_55
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 10,
              class: "bk-border"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "styled-checkbox",
                      checked: _unref(items).info.countryOfResidence == 'jp'
                    }, null, 8, _hoisted_58),
                    _createTextVNode(" 日本 ")
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "styled-checkbox",
                      checked: _unref(items).info.countryOfResidence != 'jp'
                    }, null, 8, _hoisted_60),
                    _createTextVNode(" 日本以外 ")
                  ])
                ]),
                _hoisted_61
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 2,
              class: "bk-border blue-bg no-br no-bt"
            }, {
              default: _withCtx(() => [
                _hoisted_62
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 10,
              class: "bk-border no-bt no-br"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "styled-checkbox",
                      checked: _unref(items).info.usTax == false
                    }, null, 8, _hoisted_65),
                    _createTextVNode(" 私は米国市民（米国籍保有者）又は米国居住者ではありません。 ")
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "styled-checkbox",
                      checked: _unref(items).info.usTax == true
                    }, null, 8, _hoisted_67),
                    _createTextVNode(" 私は米国市民（米国籍保有者）又は米国居住者です。 ")
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 12,
              class: "bk-border no-bl no-bt"
            }, {
              default: _withCtx(() => [
                _hoisted_68
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 3,
              class: "blue-bg bk-border no-bt p-3 fw-bold no-br text-center d-flex flex-column align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _hoisted_69
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 21,
              class: "bk-border no-bt p-3 d-flex gap-8"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_70, [
                    _hoisted_71,
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "checkbox-css",
                          style: {"width":"30px","height":"30px"},
                          checked: _unref(items).info.usTax == 'no'
                        }, null, 8, _hoisted_74),
                        _hoisted_75,
                        _hoisted_76
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "checkbox-css",
                          style: {"width":"30px","height":"30px"},
                          checked: _unref(items).info.usTax != 'no'
                        }, null, 8, _hoisted_79),
                        _hoisted_80,
                        _hoisted_81
                      ])
                    ])
                  ]),
                  _hoisted_82
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _hoisted_84,
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("div", _hoisted_86, _toDisplayString(_unref(items).info.otherPeps), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { class: "mt-8" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 2,
              class: "bk-border no-br blue-bg"
            }, {
              default: _withCtx(() => [
                _hoisted_87
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "bk-border no-br"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "styled-checkbox",
                      checked: 
                    _unref(items).financial.accountRole == _unref(accountRoles).standard
                  
                    }, null, 8, _hoisted_90),
                    _createTextVNode(" スタンダード ")
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "styled-checkbox",
                      checked: _unref(items).financial.accountRole == _unref(accountRoles).alpha
                    }, null, 8, _hoisted_92),
                    _createTextVNode(" アルファ ")
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "bk-border blue-bg"
            }, {
              default: _withCtx(() => [
                _hoisted_93,
                _hoisted_94
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 14,
              class: "bk-border no-bl"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("div", _hoisted_96, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(jpAccountTypes), (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "d-flex align-items-center",
                        key: item.value
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "styled-checkbox",
                          checked: _unref(items).financial.accountTypes.includes(item.value)
                        }, null, 8, _hoisted_97),
                        _createTextVNode(" " + _toDisplayString(item.label), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_98, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(jpInvestorDistinction), (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "d-flex align-items-center",
                        key: item.value
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "styled-checkbox",
                          checked: 
                      _unref(items).financial.investorDistinction.includes(item.value)
                    
                        }, null, 8, _hoisted_99),
                        _createTextVNode(" " + _toDisplayString(item.label), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { class: "mt-8" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 24,
              class: "bk-border blue-bg"
            }, {
              default: _withCtx(() => [
                _hoisted_100
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 8,
              class: "bk-border no-bt no-br"
            }, {
              default: _withCtx(() => [
                _hoisted_101,
                _createElementVNode("div", _hoisted_102, _toDisplayString(_unref(items).financial.financialInstiutionName) + " " + _toDisplayString(getLabelByValue(
                  _unref(items).financial.financialInstiutionType,
                  _unref(jpFinancialInstitutionTypes)
                )), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "bk-border no-bt no-br"
            }, {
              default: _withCtx(() => [
                _hoisted_103,
                _createElementVNode("div", _hoisted_104, _toDisplayString(_unref(items).financial.financialInstitutionCode), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "bk-border no-bt no-br"
            }, {
              default: _withCtx(() => [
                _hoisted_105,
                _createElementVNode("div", _hoisted_106, _toDisplayString(_unref(items).financial.branchName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "bk-border no-bt no-br"
            }, {
              default: _withCtx(() => [
                _hoisted_107,
                _createElementVNode("div", _hoisted_108, _toDisplayString(_unref(items).financial.branchCode), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "bk-border no-bt"
            }, {
              default: _withCtx(() => [
                _hoisted_109,
                _createElementVNode("div", _hoisted_110, _toDisplayString(getLabelByValue(_unref(items).financial.depositType, _unref(jpDepositTypes))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 8,
              class: "bk-border no-bt no-br"
            }, {
              default: _withCtx(() => [
                _hoisted_111,
                _createElementVNode("div", _hoisted_112, _toDisplayString(_unref(items).financial?.accountNumber), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 8,
              class: "bk-border no-bt no-br"
            }, {
              default: _withCtx(() => [
                _hoisted_113,
                _createElementVNode("div", _hoisted_114, _toDisplayString(_unref(items).financial.accountHolderFullWidth), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 8,
              class: "bk-border no-bt"
            }, {
              default: _withCtx(() => [
                _hoisted_115,
                _createElementVNode("div", _hoisted_116, _toDisplayString(_unref(items).financial.accountHolderFullWidthKatakana), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_117,
        _createVNode(_component_el_row, { class: "mt-10" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 24,
              class: "bk-border blue-bg no-bb"
            }, {
              default: _withCtx(() => [
                _hoisted_118
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 3,
              class: "blue-bg bk-border p-3 fw-bold no-br no-bb text-center d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("ご年収")
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 9,
              class: "bk-border no-br no-bb p-3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_119, _toDisplayString(getItemByValue(_unref(items).financial.annualIncome, _unref(jpMoneyRange))
                  ?.label), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 3,
              class: "blue-bg bk-border p-3 fw-bold no-br no-bb text-center d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("金融資産")
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 9,
              class: "bk-border no-bb p-3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_120, _toDisplayString(getItemByValue(_unref(items).financial.investment, _unref(jpMoneyRange))?.label), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 3,
              class: "blue-bg bk-border p-3 fw-bold no-br no-bb text-center d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("投資可能資金額")
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 9,
              class: "bk-border no-br no-bb p-3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_121, _toDisplayString(getItemByValue(_unref(items).financial.investmentFunds, _unref(jpMoneyRange))
                  ?.label), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 3,
              class: "blue-bg bk-border p-3 fw-bold no-br no-bb text-center d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("主な収入源")
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 9,
              class: "bk-border no-bb p-3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_122, _toDisplayString(getItemByValue(
                  _unref(items).financial.mainIncomeSource,
                  _unref(jpMainIncomeSources)
                )?.label), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 3,
              class: "blue-bg bk-border p-3 fw-bold no-br text-center d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("お取引動機")
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 9,
              class: "bk-border no-br p-3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_123, _toDisplayString(getItemByValue(
                  _unref(items).financial.transactionMotive,
                  _unref(jpTransactionMotives)
                )?.label), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 3,
              class: "blue-bg bk-border p-3 fw-bold no-br text-center d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("主たる資金の性格")
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 9,
              class: "bk-border p-3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_124, _toDisplayString(getItemByValue(_unref(items).financial.mainFund, _unref(jpMainFunds))?.label), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 3,
              class: "blue-bg bk-border p-3 fw-bold no-bt no-br text-center d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("資産の運用期間")
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 9,
              class: "bk-border no-br no-bt p-3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_125, _toDisplayString(getItemByValue(
                  _unref(items).financial.assetManagementPeriod,
                  _unref(jpAssetManagementPeriod)
                )?.label), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 3,
              class: "blue-bg bk-border p-3 fw-bold no-br no-bt text-center d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("投資目的")
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 9,
              class: "bk-border p-3 no-bt"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_126, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).financial.investmentPurpose, (v_item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(getLabelByValue(v_item, _unref(jpInvestmentPurposes))), 1))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 3,
              class: "blue-bg bk-border p-3 fw-bold no-br no-bt text-center d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("ご投資の経験")
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 21,
              class: "bk-border p-3 no-bt fs-7"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_127, [
                  _createElementVNode("div", _hoisted_128, [
                    _hoisted_129,
                    _createElementVNode("div", _hoisted_130, [
                      _createElementVNode("div", _hoisted_131, _toDisplayString(getLabelByValue(
                        _unref(items).financial.fx,
                        _unref(jpExperienceSelections)
                      )), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_132, [
                    _hoisted_133,
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("div", _hoisted_135, _toDisplayString(getLabelByValue(
                        _unref(items).financial.stockTradingSpot,
                        _unref(jpExperienceSelections)
                      )), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_136, [
                    _hoisted_137,
                    _createElementVNode("div", _hoisted_138, [
                      _createElementVNode("div", _hoisted_139, _toDisplayString(getLabelByValue(
                        _unref(items).financial.stockTradingCredit,
                        _unref(jpExperienceSelections)
                      )), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_140, [
                  _createElementVNode("div", _hoisted_141, [
                    _hoisted_142,
                    _createElementVNode("div", _hoisted_143, [
                      _createElementVNode("div", _hoisted_144, _toDisplayString(getLabelByValue(
                        _unref(items).financial.indexOption,
                        _unref(jpExperienceSelections)
                      )), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_145, [
                    _hoisted_146,
                    _createElementVNode("div", _hoisted_147, [
                      _createElementVNode("div", _hoisted_148, _toDisplayString(getLabelByValue(
                        _unref(items).financial.commodityFuturesTrading,
                        _unref(jpExperienceSelections)
                      )), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_149, [
                    _hoisted_150,
                    _createElementVNode("div", _hoisted_151, [
                      _createElementVNode("div", _hoisted_152, _toDisplayString(getLabelByValue(
                        _unref(items).financial.otherDerivativesTransaction,
                        _unref(jpExperienceSelections)
                      )), 1)
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_153,
        _hoisted_154,
        _createVNode(_component_el_row, { class: "fs-7 mt-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 10 }, {
              default: _withCtx(() => [
                _hoisted_155,
                _hoisted_156,
                _hoisted_157,
                _hoisted_158,
                _hoisted_159,
                _hoisted_160,
                _hoisted_161
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 9 }, {
              default: _withCtx(() => [
                _hoisted_162,
                _createVNode(_component_el_row, { class: "bk-border p-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 4 }, {
                      default: _withCtx(() => [
                        _hoisted_163,
                        _hoisted_164,
                        _hoisted_165
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_166,
                        _hoisted_167
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _hoisted_168,
                        _hoisted_169,
                        _hoisted_170
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 5,
              class: "d-flex flex-column justify-content-center align-items-center"
            }, {
              default: _withCtx(() => [
                _hoisted_171,
                _hoisted_172
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_173
      ])
    ])
  ]))
}
}

})